import type { TokenProvider } from '@klareospace/pharos-lib-types';

type TokenProviderRef = {
  setTokenProvider: (provider: TokenProvider) => void;
  tokenProvider: TokenProvider;
};

/**
 * Creates a stable token-provider pair backed by a mutable ref, removing the
 * need for a module-level `let` variable in each consuming app's api-client.
 *
 * Usage:
 *   const { setTokenProvider, tokenProvider } = createTokenProviderRef();
 *   // Call setTokenProvider(getToken) in an auth bridge useEffect.
 *   // Pass tokenProvider to ApiClientProvider.
 */
export function createTokenProviderRef(): TokenProviderRef {
  const ref: { current: TokenProvider } = {
    current: (): Promise<null> => Promise.resolve(null),
  };
  return {
    setTokenProvider: (provider: TokenProvider): void => {
      ref.current = provider;
    },
    tokenProvider: (): Promise<string | null> => ref.current(),
  };
}
